import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Typography, Box, Container } from '@mui/material';
import { BiSolidLockAlt } from 'react-icons/bi';

const PermissionDeniedPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="sm">
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        minHeight="60vh"
        textAlign="center"
        gap={3}
      >
        <BiSolidLockAlt size={64} color="#f44336" />

        <Typography variant="h4" component="h1" gutterBottom>
          Access Denied
        </Typography>

        <Typography variant="body1" color="text.secondary" paragraph>
          You don't have permission to access this page. This could be because:
        </Typography>

        <Box textAlign="left" mb={3}>
          <Typography variant="body2" color="text.secondary" component="li">
            Your account doesn't have the required feature access
          </Typography>
          <Typography variant="body2" color="text.secondary" component="li">
            Your permissions may have been recently updated
          </Typography>
          <Typography variant="body2" color="text.secondary" component="li">
            This page requires additional authorization
          </Typography>
        </Box>

        <Typography variant="body2" color="text.secondary" paragraph>
          If you believe you should have access to this page, please contact your administrator.
        </Typography>

        <Button
          variant="contained"
          color="primary"
          onClick={() => navigate('/home')}
          size="large"
        >
          Go to Dashboard
        </Button>
      </Box>
    </Container>
  );
};

export default PermissionDeniedPage;
